/* app/js/src/components/reports/scheduler-alerts-report/scheduler-alerts-report.component.scss */
.cursor-pointer {
  cursor: pointer;
}
h1 {
  margin-top: 72.4px;
}
.container {
  display: flex;
  height: 60px;
  gap: 5px;
  padding: 0 10px;
  align-items: center;
}
.container > div {
  display: flex;
  gap: 5px;
  align-items: center;
}
.container > div.dropdown {
  flex-grow: 1;
}
.container > div.calendar {
  flex-basis: 230px;
}
.container > div.buttons {
  flex-basis: 215px;
}
.container .calendar-container {
  display: flex;
  background-color: #ffffff;
  align-items: center;
  gap: 5px;
  color: #232f3a;
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  position: relative;
  cursor: pointer;
}
.container .calendar-container .calendar-icon {
  opacity: 0;
  -ms-transform: translateX(2px);
  -webkit-transform: translateX(2px);
  transform: translateX(2px);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.container .calendar-container .calendar-icon svg {
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.container .calendar-container .calendar-icon svg rect {
  fill: none;
}
.container .calendar-container .calendar-icon svg path {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  fill: #879baf;
}
.container .calendar-container .calendar-icon svg:hover {
  color: #757575;
}
.container .calendar-container .calendar-icon svg:hover path {
  fill: #757575;
}
.container .calendar-container .calendar-icon svg:active {
  -ms-transform: scale(0.7);
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
  color: #232f3a;
}
.container .calendar-container .calendar-icon svg:active path {
  fill: #232f3a;
}
.container .calendar-container:hover .calendar-icon {
  -ms-transform: translateX(0);
  -webkit-transform: translateX(0);
  transform: translateX(0);
  opacity: 1;
}
.date-picker-range-label {
  font-weight: bold;
}
.button {
  border: none;
  color: white;
  text-align: center;
  font-size: 14px;
  padding-left: 15px;
  padding-right: 15px;
  cursor: pointer;
  background-color: #000000;
  border-radius: 4px;
  margin-left: 20px;
  height: 30px;
}
.report-results {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 4px;
  width: 100%;
  height: 85vh;
  background: #ffffff;
}
/*# sourceMappingURL=scheduler-alerts-report.component.css.map */
